// extracted by mini-css-extract-plugin
export default {"container2":"PaymentFailure_container2__B3MQw","banner":"PaymentFailure_banner__pmiLw","icon":"PaymentFailure_icon__BPUbo","pattern":"PaymentFailure_pattern__2xYb+"};